














































import Component from "vue-class-component";

import ViewList from "@/views/List.vue";
import { Getter } from "vuex-class";
import SelectSearch from "@/components/forms/search/SelectSearch.vue";
import DatePickerSearch from "@/components/forms/search/DatePickerSearch.vue";
import SocleParticipationList from "@/components/socle/list/ParticipationList.vue";
import EventBus from "front-component/EventBus";
import _, {isEmpty} from "lodash";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import {Watch} from "vue-property-decorator";
import ParticipationRepository from "@/repositories/socle/ParticipationRepository";

const components = {
    SocleParticipationList,
    SelectSearch,
    DatePickerSearch,
    SelectOwner,
};

@Component({ components })
export default class ParticipationList extends ViewList {
    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;

    private optionsStatus: any[] = [
        {key: "", label: "allStatus"},
        {key: "approved", label: "approved"},
        {key: "refused", label: "refused"},
    ];
    protected filters: object = {};
    private optionsLabel: any[] = [];

    @Watch("currentOwnerUuid") private refreshList(): void {
        this.buildLabelOptions();
    }

    public mounted() {
        if (this.currentOwnerUuid) {
            this.buildLabelOptions();
        }
    }

    public updateFilter(filter: object): void {
        this.filters = Object.assign({}, this.filters, filter);
    }

    private updateOwnerFilter(selectedOwner: string): void {
        EventBus.$emit("update-filter", _.set({}, "entityFilter", selectedOwner));
    }

    private buildLabelOptions(): void {
        this.optionsLabel = [];
        const paramsGetOwnerData = {
            fields: [
                "campaign.label",
                "campaign.externalCode",
                "campaign.uuid",
            ],
            filters: {
                listLabel: true,
                ownerUuid: this.currentOwnerUuid
            }
        };

        ParticipationRepository.get(paramsGetOwnerData).then((data: object[]) => {
            this.optionsLabel.push({key: "", label: "allCatalogs"});
            _.forEach(data, (line) => {
                let externalCode: boolean|string = _.get(line, "externalCode", false);
                externalCode = !isEmpty(externalCode) ? " (" + externalCode + ")" : "";

                this.optionsLabel.push({
                    key: _.get(line, "uuid"),
                    label: _.get(line, "label") + externalCode
                });
            });
        });
    }
}
